import { Action } from '@ngrx/store';
import { PasswordSettingsInterface } from 'app/site-settings/models/password-settings.model';

import { SiteSettingActionType } from './site-setings-action-type.enum';

export class LoadPasswordSettings implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadPasswordSettings;

  // public readonly payload: any = undefined;
  constructor(public readonly payload: number) { }
}

export class LoadPasswordSettingsCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadPasswordSettingsCompleted;

  constructor(public readonly payload: PasswordSettingsInterface) { }
  // constructor(public readonly payload: number) { }
}

export class LoadPasswordSettingsFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadPasswordSettingsFailed;

  constructor(public readonly payload: string) { }
}
export class UpdatePasswordSettings implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdatePasswordSettings;

  constructor(public readonly payload: PasswordSettingsInterface) {  }
}

export class UpdatePasswordSettingsCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdatePasswordSettingsCompleted;

  constructor(public readonly payload: PasswordSettingsInterface) { }
}

export class UpdatePasswordSettingsFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdatePasswordSettingsFailed;

  constructor(public readonly payload: string) { }
}
